/* ============================================================
   Enhanced product card controller  (<hm-product-card>)
   - pack-size dropdown  → real variants
   - pack-of-N dropdown  → quantity-break tiers (synced to PDP)
   - qty stepper         → kept in sync with the pack-of-N dropdown
   - live price + savings, computed with the SAME formula as the PDP
   - add to cart          → submits the theme's own product-form
                            (native AJAX add + cart drawer open/refresh)
   ============================================================ */
(function () {
  /* ---- wishlist heart controller (registered once, delegated) ---- */
  if (!window.__hmWishUI) {
    window.__hmWishUI = true;
    var paintOne = function (btn, on) {
      btn.classList.toggle('is-wished', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      btn.setAttribute('aria-label', on ? 'Remove from wishlist' : 'Add to wishlist');
    };
    window.__hmWishPaint = function () {
      if (!window.Wishlist) return;
      var set = {};
      window.Wishlist.getAll().forEach(function (h) { set[h] = 1; });
      document.querySelectorAll('[data-wishlist-handle]').forEach(function (btn) {
        paintOne(btn, !!set[btn.getAttribute('data-wishlist-handle')]);
      });
    };
    document.addEventListener('click', function (e) {
      var btn = e.target.closest ? e.target.closest('[data-wishlist-toggle]') : null;
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      if (!window.Wishlist) return;
      var on = window.Wishlist.toggle(btn.getAttribute('data-wishlist-handle'));
      paintOne(btn, on);
      if (on) { btn.classList.remove('hm-wish--pop'); void btn.offsetWidth; btn.classList.add('hm-wish--pop'); }
    });
    document.addEventListener('wishlist:change', function () { window.__hmWishPaint(); });
  }

  if (customElements.get('hm-product-card')) return;

  /* ---- money format ----------------------------------------
     Matches your live PDP output: "₹ 1,499" (₹ + space, no decimals,
     Indian grouping). To show paise like "₹113.00" instead, set
     SYMBOL = '₹' and DECIMALS = 2.                              */
  var SYMBOL = '₹ ';
  var DECIMALS = 0;
  function money(cents) {
    var v = Math.max(0, Math.round(cents)) / 100;
    return SYMBOL + v.toLocaleString('en-IN', {
      minimumFractionDigits: DECIMALS,
      maximumFractionDigits: DECIMALS
    });
  }
  var MAX_QTY = 99;
  function pad(n) { return String(n).padStart(2, '0'); }

  /* ---- shared 1s ticker for all dispatch countdowns -------- */
  var dispatchEls = new Set();
  function tick() { dispatchEls.forEach(updateDispatch); }
  function updateDispatch(el) {
    var parts = (el.dataset.cutoff || '').split(':');
    if (parts.length < 2) { el.hidden = true; return; }
    var cutoff = (parseInt(parts[0], 10) || 0) * 3600 + (parseInt(parts[1], 10) || 0) * 60;
    var off = parseInt(el.dataset.offset, 10) || 0;            // store UTC offset, minutes
    var d = new Date(Date.now() + off * 60000);               // store wall-clock via UTC getters
    var now = d.getUTCHours() * 3600 + d.getUTCMinutes() * 60 + d.getUTCSeconds();
    if (now < cutoff) {
      var r = cutoff - now;
      var hh = Math.floor(r / 3600); r %= 3600;
      var t = el.querySelector('.hm-countdown');
      if (t) t.textContent = pad(hh) + ':' + pad(Math.floor(r / 60)) + ':' + pad(r % 60);
      el.hidden = false;
    } else {
      el.hidden = true;                                        // after cutoff; returns after store midnight
    }
  }
  setInterval(tick, 1000);

  class HMProductCard extends HTMLElement {
    connectedCallback() {
      if (this._init) return;
      this._init = true;
      try { this.setup(); } catch (e) { console.warn('[hm-card]', e); }
    }
    disconnectedCallback() { if (this._dispatch) dispatchEls.delete(this._dispatch); }

    setup() {
      // variant data
      var data = this.querySelector('script.hm-variants');
      this.variants = data ? JSON.parse(data.textContent) : [];
      this.byId = {};
      this.variants.forEach(function (v) { this.byId[v.id] = v; }, this);

      // tiers come straight from the rendered .bundle-item nodes (source of truth)
      this.bundleItems = Array.from(this.querySelectorAll('.bundle-item'));
      this.tiers = this.bundleItems.map(function (b) {
        return {
          el: b,
          qty: parseInt(b.dataset.qty, 10) || 1,
          percent: parseFloat(b.dataset.percent) || 0,
          fixed: parseFloat(b.dataset.fixed) || 0,        // rupees
          compareMode: b.dataset.compareMode || 'compare_price',
          label: b.dataset.label || ('Pack of ' + b.dataset.qty)
        };
      });

      // elements
      this.els = {
        save: this.querySelector('.hm-save'),
        savePct: this.querySelector('.hm-save-pct'),
        now: this.querySelector('.hm-price .now'),
        was: this.querySelector('.hm-price .was'),
        saving: this.querySelector('.hm-price .saving'),
        vDrop: this.querySelector('.variant-dropdown'),
        vTrigger: this.querySelector('.variant-trigger'),
        vItems: Array.from(this.querySelectorAll('.variant-item')),
        bDrop: this.querySelector('.bundle-dropdown'),
        bTrigger: this.querySelector('.bundle-trigger'),
        qtyInput: this.querySelector('.qty input'),
        qtyMinus: this.querySelector('.qty button:first-child'),
        qtyPlus: this.querySelector('.qty button:last-child'),
        idInput: this.querySelector('input[name="id"]'),
        formQty: this.querySelector('input[name="quantity"]'),
        cart: this.querySelector('.hm-cart'),
        dispatch: this.querySelector('.dispatch')
      };

      if (this.els.dispatch) { this._dispatch = this.els.dispatch; dispatchEls.add(this._dispatch); updateDispatch(this._dispatch); }

      // initial state: first available variant, qty from the active tier (or 1)
      var firstAvail = this.variants.filter(function (v) { return v.available; })[0] || this.variants[0];
      this.variantId = firstAvail ? firstAvail.id : null;
      var active = this.tiers.filter(function (t) { return t.el.classList.contains('active'); })[0];
      this.qty = active ? active.qty : (this.tiers[0] ? this.tiers[0].qty : 1);

     this.bind();
      this.render();

      if (window.__hmWishPaint) window.__hmWishPaint();
    }

    bind() {
      var self = this;

      // dropdown open/close
      if (this.els.vTrigger) {
        this.els.vTrigger.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          self.toggle(self.els.vDrop);
        });
      }
      if (this.els.bTrigger) {
        this.els.bTrigger.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          self.toggle(self.els.bDrop);
        });
      }

      // variant pick
      this.els.vItems.forEach(function (item) {
        item.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          if (item.hasAttribute('disabled')) return;
          self.variantId = parseInt(item.dataset.variantId, 10);
          self.close();
          self.render();
        });
      });

      // pack-of-N pick
      this.tiers.forEach(function (t) {
        t.el.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          self.qty = t.qty;
          self.close();
          self.render();
        });
      });

      // stop touch & pointer bubbling from dragging parent carousels/sliders
      var stopBubbling = function (el) {
        if (!el) return;
        ['pointerdown', 'pointermove', 'touchstart', 'touchmove', 'touchend'].forEach(function (evt) {
          el.addEventListener(evt, function (e) {
            e.stopPropagation();
          }, { passive: true });
        });
      };
      stopBubbling(this.els.bDrop);
      stopBubbling(this.els.vDrop);
      stopBubbling(this.els.qtyMinus);
      stopBubbling(this.els.qtyPlus);
      stopBubbling(this.els.qtyInput);

      // qty stepper (clamped 1..MAX_QTY; typed values commit on change/blur)
      var setQty = function (n) {
        n = parseInt(n, 10);
        self.qty = Math.min(MAX_QTY, Math.max(1, isNaN(n) ? 1 : n));
        self.render();
      };
      if (this.els.qtyMinus) this.els.qtyMinus.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); setQty(self.qty - 1); });
      if (this.els.qtyPlus) this.els.qtyPlus.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); setQty(self.qty + 1); });
      if (this.els.qtyInput) {
        var inp = this.els.qtyInput;
        inp.setAttribute('max', MAX_QTY);
        inp.setAttribute('pattern', '[0-9]*');
        // select on focus so a tap + digit replaces the value instead of appending ("1" → "19")
        inp.addEventListener('focus', function () { setTimeout(function () { try { inp.select(); } catch (err) {} }, 0); });
        inp.addEventListener('click', function (e) { e.stopPropagation(); });
        inp.addEventListener('input', function () {
          var digits = String(inp.value).replace(/\D/g, '').slice(0, String(MAX_QTY).length);
          if (digits !== String(inp.value)) inp.value = digits;
          var n = parseInt(digits, 10);
          if (n >= 1) { self.qty = Math.min(MAX_QTY, n); self.render(true); }
        });
        inp.addEventListener('change', function () { setQty(inp.value); });
        inp.addEventListener('blur', function () { setQty(inp.value); });
        inp.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); inp.blur(); } });
      }

      // keep the form fresh right before the native submit fires
      if (this.els.cart) this.els.cart.addEventListener('click', function () { self.syncForm(); });

      // close on outside click / Esc / scroll
      document.addEventListener('click', function (e) { if (!self.contains(e.target)) self.close(); });
      this.addEventListener('keydown', function (e) { if (e.key === 'Escape') self.close(); });
      window.addEventListener('scroll', function (e) { if (!self.contains(e.target)) self.close(); }, { passive: true });
      document.addEventListener('scroll', function (e) {
        if (self.contains(e.target)) return;
        if (e.target && e.target.classList && e.target.classList.contains('product-grid')) {
          self.close();
        }
      }, true);
    }

    toggle(dd) {
      if (!dd) return;
      var open = dd.classList.contains('open');
      this.close();
      if (!open) {
        dd.classList.add('open');
        this.classList.add('hm-open');
        var item = this.closest('.grid__item, li');
        if (item) item.classList.add('hm-item-open');
        var grid = this.closest('.product-grid');
        if (grid) grid.classList.add('hm-grid-has-open');
      }
    }
    close() {
      if (this.els.vDrop) this.els.vDrop.classList.remove('open');
      if (this.els.bDrop) this.els.bDrop.classList.remove('open');
      this.classList.remove('hm-open');
      var item = this.closest('.grid__item, li');
      if (item) item.classList.remove('hm-item-open');
      var grid = this.closest('.product-grid');
      if (grid) grid.classList.remove('hm-grid-has-open');
    }

    // PDP-identical maths:  price = base × qty × (1 − pct/100) − (fixed×100)
    totals(variant, tier, qty) {
      var base = variant ? variant.price : 0;
      var cmpAt = (variant && variant.compare_at_price) ? variant.compare_at_price : 0;
      var pctLeft = 1 - ((tier ? tier.percent : 0) / 100);
      var fixed = (tier ? tier.fixed : 0) * 100;
      var price = Math.max(0, Math.round(base * qty * pctLeft - fixed));
      var cmpBase = base;
      if (cmpAt > base && (!tier || tier.compareMode === 'compare_price')) cmpBase = cmpAt;
      var cmpTotal = cmpBase * qty;
      if (cmpTotal <= price) cmpTotal = 0;
      return { price: price, compare: cmpTotal };
    }

    render(typing) {
      var v = this.byId[this.variantId];
      var matched = this.tiers.filter(function (t) { return t.qty === this.qty; }, this)[0] || null;

      // top price block uses the selected variant + (matched tier, or no discount for a custom qty)
      var top = this.totals(v, matched, this.qty);
      if (this.els.now) this.els.now.textContent = money(top.price);
      if (this.els.was) { if (top.compare) { this.els.was.textContent = money(top.compare); this.els.was.hidden = false; } else this.els.was.hidden = true; }
      if (this.els.saving) { if (top.compare) { this.els.saving.textContent = 'Save ' + Math.floor((top.compare - top.price) / top.compare * 100) + '%'; this.els.saving.hidden = false; } else this.els.saving.hidden = true; }
      if (this.els.save) {
        if (top.compare) {
          if (this.els.savePct) this.els.savePct.textContent = money(top.compare - top.price);
          this.els.save.hidden = false;
        } else this.els.save.hidden = true;
      }

  // each pack-of-N row: % OFF vs the regular selling price (base × qty), not compare-at
      this.tiers.forEach(function (t) {
        var s = this.totals(v, t, t.qty);
        var regular = (v ? v.price : 0) * t.qty;   // normal selling line total at this qty
        var pctEl = t.el.querySelector('.bundle-item__pct');
        if (pctEl) {
          if (t.qty > 1 && regular > s.price) {
            var pct = Math.round((regular - s.price) / regular * 100);
            pctEl.textContent = pct + '% OFF';
            pctEl.hidden = pct <= 0;
          } else {
            pctEl.hidden = true;
          }
        }
        t.el.classList.toggle('active', t.qty === this.qty);
      }, this);

      // triggers + active states (CSS draws the arrows as ::after, so textContent is safe)
      if (this.els.vTrigger && v) this.els.vTrigger.textContent = v.title;
      this.els.vItems.forEach(function (item) {
        item.classList.toggle('active', parseInt(item.dataset.variantId, 10) === this.variantId);
      }, this);
      if (this.els.bTrigger) {
        if (matched) {
          var mReg = (v ? v.price : 0) * matched.qty;
          var mT = this.totals(v, matched, matched.qty);
          var mPct = (matched.qty > 1 && mReg > mT.price) ? Math.round((mReg - mT.price) / mReg * 100) : 0;
          this.els.bTrigger.textContent = matched.label + (mPct > 0 ? '  ·  ' + mPct + '% OFF' : '');
        } else {
          this.els.bTrigger.textContent = 'Qty: ' + this.qty;
        }
      }

      // stepper value
      if (this.els.qtyInput && !typing && String(this.els.qtyInput.value) !== String(this.qty)) this.els.qtyInput.value = this.qty;
      if (this.els.qtyMinus) this.els.qtyMinus.disabled = this.qty <= 1;
      if (this.els.qtyPlus) this.els.qtyPlus.disabled = this.qty >= MAX_QTY;

      // sold-out handling
    // sold-out handling
      if (this.els.cart) {
        var sold = !v || !v.available;
        this.els.cart.disabled = sold;
        var cartLabel = this.els.cart.querySelector('.hm-cart__label') || this.els.cart;
        cartLabel.textContent = sold
          ? (this.els.cart.dataset.soldoutLabel || 'Sold out')
          : (this.els.cart.dataset.addLabel || '🛒 Add to cart');
      }

      this.syncForm();
    }

    syncForm() {
      if (this.els.idInput && this.variantId) this.els.idInput.value = this.variantId;
      if (this.els.formQty) this.els.formQty.value = this.qty;
    }
  }

  customElements.define('hm-product-card', HMProductCard);
})();